import type { ReactNode } from "react";

import type { IIconProps } from "@atoms/icon";
import type { IModalProps } from "@atoms/modal";
import type { IFastButtonProps } from "@fastFields/fastButton";
import type { IFastLinkButtonTypes } from "@fastFields/fastLinkButton";

export enum IAlertVariantsEnum {
  Information = "information",
  Error = "error",
  Warning = "warning",
  Success = "success",
  CustomIcon = "customIcon",
}

export enum IAlertButtonsTypeEnum {
  Basic = "basic",
  Stretch = "stretch",
}

export enum IAlertAlignmentEnum {
  Horizontal = "horizontal",
  Vertical = "vertical",
}

export interface IAlertProps extends IModalProps {
  title?: string;
  description?: string;
  variant?: IAlertVariantsEnum;
  buttonsType?: IAlertButtonsTypeEnum;
  noIcon?: boolean;
  customIcon?: Omit<IIconProps, "customSize" | "fontSize">;
  submitButtonProps?: IFastButtonProps;
  cancelButtonProps?: IFastButtonProps;
  linkButtonType?: IFastLinkButtonTypes;
  alignment?: IAlertAlignmentEnum;
  noMaxWidth?: boolean;
  customChildren?: ReactNode | undefined;
}

export type IShowAlertParams = Omit<IAlertProps, "open">;

export interface IAlertStore {
  alertProps: IAlertProps;
  setAlertProps: (props: IAlertProps) => void;
  reset: () => void;
}

export type IAlertUtilProps = Omit<IAlertProps, "open">;
